<template>
	<div><a class="popover-toggler" @click.stop ref="toggler" href="javascript:void(0)" tabindex="0" role="button" data-toggle="popover" :title="popoverTitle"><i :class="['fad', 'icon', popoverIcon]"></i></a></div>
</template>

<script>
	import _ from 'lodash'
	import $ from 'jquery'

	export default {
		props: ['modelValue', 'options'],
		data() {
			return {
				settings: {
					preventCloseDropdown: true,
					contentElement: null,
					content: 'No Content',
					icon: 'info-circle',
					placement: 'right'
				},
				popover: null,
				eventBinded: false
			}
		},
		computed: {
			popoverIcon() {
				return 'fa-' + this.settings.icon
			},
			popoverTitle() {
				return this.settings.title
			},
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge({}, this.settings, val)
					this.popover = $(this.$refs.toggler).popover({
						trigger: "focus",
						placement: this.settings.placement,
						html: true,
						content: this.settings.contentElement ? this.settings.contentElement : this.settings.content
					})

					if (this.settings.contentElement) {
						this.settings.contentElement.hide()

						this.popover.on('show.bs.popover', (e) => {
							this.settings.contentElement.show()
						})
					}

					this.popover.on('shown.bs.popover', (e) => {
						if (this.settings.preventCloseDropdown && !this.eventBinded) {
							// Use namespaced events for easier cleanup
							$('.popover').on('mousedown.popoverComponent', () => {
								var body = _.head(document.getElementsByTagName('body'))
								body.popover_clicked = !body.force_dropdown_close
								body.force_dropdown_close = false
							})

							$('.popover').on('click.popoverComponent', () => {
								var body = _.head(document.getElementsByTagName('body'))
								body.popover_clicked = !body.force_dropdown_close
								body.force_dropdown_close = false
							})
							this.eventBinded = true
						}
					})
				}
			}
		},
		mounted() {
			this.settings = _.merge({}, this.settings, this.options)

		},
		beforeUnmount() {
			// Remove namespaced event listeners from .popover elements
			$('.popover').off('mousedown.popoverComponent')
			$('.popover').off('click.popoverComponent')

			// Destroy the popover instance if it exists
			if (this.popover) {
				this.popover.popover('dispose')
				this.popover.off('show.bs.popover shown.bs.popover')
				this.popover = null
			}

			// Reset event binding flag
			this.eventBinded = false
		}
	}
</script>
<style>
	.popover-toggler .icon {
		font-size: 1.3rem;
		cursor: pointer !important
	}

	a.popover-toggler:focus {
		outline: none !important;
	}

	.popover .toolbar {
		background-color: #eee;
		margin: 0 -9px -6px -9px;
		padding: 3px;
		list-style: none;
		border-top: 1px solid #e1e1e1;
		border-bottom-left-radius: 3px;
		border-bottom-right-radius: 3px;
	}

	.popover .toolbar li {
		display: inline-block;
		padding: 3px;
		border-left: 1px solid #d5d5d5;
	}
</style>
